window.addEventListener('error', function(event) {
  if (event.error && event.error.name === 'DataCloneError') {
    console.warn('DataCloneError intercepted:', event.error.message);
    event.preventDefault();
    return false;
  }
});

const originalPostMessage = window.postMessage;
window.postMessage = function(message, targetOrigin, transfer) {
  try {
    function containsFunctions(obj) {
      if (typeof obj === 'function') return true;
      if (obj === null || typeof obj !== 'object') return false;
      if (Array.isArray(obj)) return obj.some(item => containsFunctions(item));
      for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (containsFunctions(obj[key])) return true;
        }
      }
      return false;
    }

    if (containsFunctions(message)) {
      console.warn('postMessage blocked: contains functions', message);
      return false;
    }

    if (typeof message === 'object' && message !== null) {
      try {
        structuredClone ? structuredClone(message) : JSON.parse(JSON.stringify(message));
      } catch (cloneError) {
        console.warn('postMessage blocked: cannot clone message', cloneError);
        return false;
      }
    }

    return originalPostMessage.call(this, message, targetOrigin, transfer);
  } catch (error) {
    console.warn('postMessage blocked due to error:', error);
    return false;
  }
};

if (window.dataLayer) {
  const originalDataLayerPush = window.dataLayer.push;
  window.dataLayer.push = function(...args) {
    try {
      function containsFunctions(obj) {
        if (typeof obj === 'function') return true;
        if (obj === null || typeof obj !== 'object') return false;
        if (Array.isArray(obj)) return obj.some(item => containsFunctions(item));
        for (let key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (containsFunctions(obj[key])) return true;
          }
        }
        return false;
      }

      if (args.some(arg => containsFunctions(arg))) {
        console.warn('dataLayer.push blocked: contains functions', args);
        return 0;
      }

      return originalDataLayerPush.apply(this, args);
    } catch (error) {
      console.warn('dataLayer.push blocked due to error:', error);
      return 0;
    }
  };
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.postMessage !== originalPostMessage) {
    window.postMessage = originalPostMessage;
  }
});

const originalCreateElement = document.createElement.bind(document);
document.createElement = function(tagName) {
  const element = originalCreateElement(tagName);
  if (tagName.toLowerCase() === 'iframe') {
    const originalIframePostMessage = element.contentWindow?.postMessage;
    if (originalIframePostMessage) {
      element.contentWindow.postMessage = function(message, targetOrigin, transfer) {
        try {
          function containsFunctions(obj) {
            if (typeof obj === 'function') return true;
            if (obj === null || typeof obj !== 'object') return false;
            if (Array.isArray(obj)) return obj.some(item => containsFunctions(item));
            for (let key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (containsFunctions(obj[key])) return true;
              }
            }
            return false;
          }

          if (containsFunctions(message)) {
            console.warn('iframe postMessage blocked: contains functions', message);
            return false;
          }

          return originalIframePostMessage.call(this, message, targetOrigin, transfer);
        } catch (error) {
          console.warn('iframe postMessage blocked due to error:', error);
          return false;
        }
      };
    }
  }
  return element;
};
